import BugsnagPluginReact from '@bugsnag/plugin-react';

const environment = import.meta.env.VITE_APP_NODE_ENV || 'local';
const appVersion = import.meta.env.VITE_APP_VERSION || '1.0.0';

export const config = {
  environment,
  bugsnag: {
    apiKey: 'd2e371018c0cb51f0a021fb43a04b030',
    plugins: [new BugsnagPluginReact()],
    enabledReleaseStages: [
      'develop',
      'staging',
      'qaload',
      'production',
      'sandbox',
      'sandbox2',
      'sandbox3',
    ],
    releaseStage: environment,
    appVersion,
    appType: 'client',
    metadata: { app: {
      service: 'Frontend',
    } },
  },
};

export const isTest = () => {
  return config.environment === 'test';
};

export const isLocal = () => {
  return config.environment === 'local';
};
